export default "__VITE_ASSET__cSLu2aTJ__"